import { Badge, HStack, Tooltip } from '@chakra-ui/react';
import { CheckIcon, CloseIcon, TimeIcon } from '@chakra-ui/icons';
import { AbsenceStatus } from '../../types';
import { useIntl } from 'react-intl';
import { useSuIntl } from '../../hooks/useSuIntl';

type StatusConfig = {
    colorScheme: string;
    icon: React.ReactElement;
    tooltipKey: string;
};

const statusConfigMap: Record<AbsenceStatus, StatusConfig> = {
    [AbsenceStatus.APPROVED]: {
        colorScheme: 'green',
        icon: <CheckIcon boxSize={3} />,
        tooltipKey: 'absence.approvedAt',
    },
    [AbsenceStatus.REJECTED]: {
        colorScheme: 'red',
        icon: <CloseIcon boxSize={3} />,
        tooltipKey: 'absence.rejectedAt',
    },
    [AbsenceStatus.CANCELLED]: {
        colorScheme: 'gray',
        icon: <CloseIcon boxSize={3} />,
        tooltipKey: 'absence.cancelledAt',
    },
    [AbsenceStatus.PENDING]: {
        colorScheme: 'yellow',
        icon: <TimeIcon boxSize={3} />,
        tooltipKey: 'absence.pendingSince',
    },
};

type AbsenceReviewStatusBadgeProps = {
    status: AbsenceStatus;
    date: string | null;
};

export const AbsenceReviewStatusBadge: React.FC<AbsenceReviewStatusBadgeProps> = ({ status, date }) => {
    const intl = useIntl();
    const { formatDate, formatTime } = useSuIntl();

    const config = statusConfigMap[status];

    if (!date) {
        return null;
    }

    const formattedDate = formatDate(date);
    const formattedTime = formatTime(date);
    const tooltipText = intl.formatMessage({ id: config.tooltipKey }, { date: `${formattedDate} ${formattedTime} ` });

    return (
        <Tooltip label={tooltipText} hasArrow>
            <Badge colorScheme={config.colorScheme} borderRadius="md" cursor="default">
                <HStack spacing={1}>
                    {config.icon}
                    <span>{formattedDate}</span>
                </HStack>
            </Badge>
        </Tooltip>
    );
};
